export const mediaState = Object.freeze({
  NEW: 'new',
  CONFIRMED: 'confirmed',
});
